import { WebPlugin } from '@capacitor/core';
export class CallNotificationWeb extends WebPlugin {
    async echo(options) {
        console.log('ECHO', options);
        return options;
    }
    /**
     * Implementación web de showCallNotification.
     * Aquí puedes usar la API de notificaciones del navegador o simplemente loguear.
     */
    async showCallNotification(options) {
        console.log('showCallNotification', options);
        // Verificar permisos de notificación
        if (Notification.permission !== 'granted') {
            const permission = await Notification.requestPermission();
            if (permission !== 'granted') {
                return { status: 'Permiso de notificación denegado' };
            }
        }
        // Crear y mostrar la notificación
        const notification = new Notification(options.title, {
            body: options.body,
        });
        // Manejar clics en la notificación
        notification.onclick = () => {
            console.log('Notificación de llamada clicada');
            // Implementa la lógica necesaria
        };
        return { status: 'Notificación mostrada en web' };
    }
}
//# sourceMappingURL=web.js.map